module.exports = __webpack_public_path__ + "img/BigToe.03a8cd90.png";